/**
 * Page History Tracker
 * Tracks the pages visited by the user including repeated visits
 * Stores page titles and URLs in localStorage
 */
(function () {
  // Configuration - can be modified
  const CONFIG = {
    HISTORY_KEY: "siccas_page_history",
    MAX_HISTORY_LENGTH: 10, // This can be changed to any desired number
  };

  // Function to get current page data with timestamp
  function getCurrentPageData() {
    return {
      title: document.title || "Unnamed Page",
      url: window.location.href,
      timestamp: new Date().toISOString(),
    };
  }

  // Function to load page history from localStorage
  function loadPageHistory() {
    try {
      const savedHistory = localStorage.getItem(CONFIG.HISTORY_KEY);
      return savedHistory ? JSON.parse(savedHistory) : [];
    } catch (error) {
      console.error("Error loading page history:", error);
      return [];
    }
  }

  // Function to save page history to localStorage
  function savePageHistory(history) {
    try {
      localStorage.setItem(CONFIG.HISTORY_KEY, JSON.stringify(history));
    } catch (error) {
      console.error("Error saving page history:", error);
    }
  }

  // Function to update page history - always adds current page
  function updatePageHistory() {
    // Get current page data
    const currentPage = getCurrentPageData();

    // Load existing history
    let history = loadPageHistory();

    // Always add current page to the beginning of the array
    history.unshift(currentPage);

    // Limit history to MAX_HISTORY_LENGTH items
    if (history.length > CONFIG.MAX_HISTORY_LENGTH) {
      history = history.slice(0, CONFIG.MAX_HISTORY_LENGTH);
    }

    // Save updated history
    savePageHistory(history);
  }

  // Function to get formatted page history as string
  function getFormattedPageHistory() {
    const history = loadPageHistory();

    if (history.length === 0) {
      return "No page history available";
    }

    // Format history as two columns: page name, URL
    return history
      .map((page, index) => `${index + 1}. ${page.title} | ${page.url}`)
      .join("\n");
  }

  // Function to set maximum history length
  function setMaxHistoryLength(length) {
    if (typeof length === "number" && length > 0) {
      CONFIG.MAX_HISTORY_LENGTH = length;

      // Trim existing history if needed
      const history = loadPageHistory();
      if (history.length > CONFIG.MAX_HISTORY_LENGTH) {
        savePageHistory(history.slice(0, CONFIG.MAX_HISTORY_LENGTH));
      }

      return true;
    }
    return false;
  }

  // Wait for document to be ready
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // Document already ready, update history immediately
    updatePageHistory();
  } else {
    // Wait for document to be ready
    document.addEventListener("DOMContentLoaded", updatePageHistory);
  }

  // Expose functions to global scope for use in other scripts
  window.siccasPageHistory = {
    getHistory: loadPageHistory,
    getFormattedHistory: getFormattedPageHistory,
    clearHistory: function () {
      localStorage.removeItem(CONFIG.HISTORY_KEY);
    },
    setMaxLength: setMaxHistoryLength,
    getConfig: function () {
      return { ...CONFIG }; // Return a copy of the config
    },
  };
})();
